import {
  RtbCampaignBasicFormModel,
  RtbCampaignBasicFormModelConstructorParams
} from './RtbCampaignBasicFormModel';
import { AdType, DailyBudgetPlan } from 'core/rtbCampaign/RtbCampaign';
import { AbstractDisplayFormModel } from './DisplayFormModel';
export interface WebDisplayFormModel extends RtbCampaignBasicFormModel {
  readonly canEditBudgetPlan: boolean;
  readonly canEditPriceModel: boolean;
}

abstract class AbstractWebDisplayFormModel extends AbstractDisplayFormModel {
  override get campaignAdType (): AdType {
    return AdType.WEB_DISPLAY;
  }
}

export class EditWebDisplayFormModel extends AbstractWebDisplayFormModel {
  constructor (...args: RtbCampaignBasicFormModelConstructorParams) {
    super('edit', ...args);
  }
  get canEditBudgetPlan (): boolean {
    return false;
  }
  get canEditPriceModel (): boolean {
    return false;
  }
}

export class CreateWebDisplayFormModel extends AbstractWebDisplayFormModel {

  constructor (...args: RtbCampaignBasicFormModelConstructorParams) {
    super('create', ...args);
    this.modelDailyBudgetType = DailyBudgetPlan.DAILY;
  }
  get canEditBudgetPlan (): boolean {
    return true;
  }
  get canEditPriceModel (): boolean {
    return true;
  }
}
